import React from 'react';
import { Toggle } from '../../components/ui/toggle';
import { mlecEligible, mlecIneligibleReason } from '../../domain/rules/mlecRules';

/**
 * CONF-94. The classic cards' MLEC control, shared by BaselineConfigCard and
 * ExpansionConfigCard. Built on the same Toggle the cards use for end-to-end
 * encryption so it sits in its row as one of the row's controls: Off on the
 * left, On on the right, vertically centred against the neighbouring selects.
 *
 * Live only on hardware that supports MLEC and on that vendor's eligible JBOD
 * (mlecRules is the single definition); otherwise locked, with the reason as
 * the tooltip. R12 clears the flag if the JBOD or vendor changes underneath it,
 * so the switch snaps to Off on its own.
 */
export const MlecToggle = ({ config, updateConfig }) => {
  const eligible = mlecEligible(config.hardwareVendor, config.jbodSize);
  const reason = mlecIneligibleReason(config.hardwareVendor, config.jbodSize);

  return (
    <div>
      <label>MLEC</label>
      <Toggle
        leftLabel="Off"
        rightLabel="On"
        ariaLabel="MLEC"
        title={reason || 'Multi-Level Erasure Coding'}
        isRightActive={Boolean(config.hybridMLEC)}
        onToggle={() => updateConfig({ hybridMLEC: !config.hybridMLEC })}
        disabled={!eligible}
        labelClassName="text-xs text-white"
        className="flex items-center h-10"
      />
    </div>
  );
};
